import { RadioGroup } from 'radix-ui';
import { useId } from 'react';

import { Grid } from '@/components/ui/layout/layout';

import {
  APP_ACCESS_MODE_DESCRIPTIONS,
  APP_ACCESS_MODE_LABELS,
  APP_ACCESS_MODES,
} from './app-access-mode';

import type { AppAccessMode } from '@electron/shared/types';

type AppAccessModePickerProps = {
  value: AppAccessMode;
  onValueChange: (mode: AppAccessMode) => void;
  disabled?: boolean;
};

export const AppAccessModePicker = ({
  value,
  onValueChange,
  disabled,
}: AppAccessModePickerProps) => {
  const id = useId();

  return (
    <RadioGroup.Root
      value={value}
      onValueChange={(mode) => onValueChange(mode as AppAccessMode)}
      disabled={disabled}
      aria-label="Which apps can Littlebird read?"
      asChild
    >
      <Grid className="grid-cols-[repeat(auto-fit,minmax(min(100%,14rem),1fr))] gap-3">
        {APP_ACCESS_MODES.map((mode) => (
          <RadioGroup.Item
            key={mode}
            value={mode}
            aria-labelledby={`${id}-${mode}-label`}
            aria-describedby={`${id}-${mode}-description`}
            className="group flex min-w-0 flex-col items-start gap-4 rounded-xl border border-border-strong bg-surface p-4 text-left focus-ring hover:enabled:bg-surface-hover data-[state=checked]:border-accent data-[state=checked]:bg-surface-active disabled:cursor-not-allowed disabled:opacity-50"
          >
            <span
              aria-hidden="true"
              className="inline-flex size-4 shrink-0 items-center justify-center rounded-full border border-foreground-muted group-data-[state=checked]:border-foreground"
            >
              <RadioGroup.Indicator className="size-2 rounded-full bg-foreground" />
            </span>
            <span className="min-w-0">
              <span
                id={`${id}-${mode}-label`}
                className="block text-sm font-medium text-foreground"
              >
                {APP_ACCESS_MODE_LABELS[mode]}
              </span>
              <span
                id={`${id}-${mode}-description`}
                className="mt-1 block text-sm text-foreground-muted"
              >
                {APP_ACCESS_MODE_DESCRIPTIONS[mode]}
              </span>
            </span>
          </RadioGroup.Item>
        ))}
      </Grid>
    </RadioGroup.Root>
  );
};
